import React from 'react';
import { 
  Api as ApiIcon,
  CompareArrows as CompareArrowsIcon,
  OnlinePrediction as OnlinePredictionIcon
} from '@mui/icons-material';

import ToolAppLayout from '../../layouts/ToolAppLayout';

import ApiClient from './ApiClient';
import WebhookTester from './WebhookTester';
import ApiResponseDiff from './ApiResponseDiff';

const toolCategories = [
  {
    name: 'Clients & Endpoints',
    tools: [
      { name: 'REST Client', description: 'Test APIs, send HTTP requests, and inspect responses', path: 'api-client', icon: <ApiIcon fontSize="small" />, component: ApiClient },
      { name: 'Webhook Tester', description: 'Generate a temporary URL to catch and inspect incoming webhooks', path: 'webhook-tester', icon: <OnlinePredictionIcon fontSize="small" />, component: WebhookTester },
    ]
  },
  {
    name: 'Analytics',
    tools: [
      { name: 'Response Diff', description: 'Compare JSON responses from two different API endpoints', path: 'response-diff', icon: <CompareArrowsIcon fontSize="small" />, component: ApiResponseDiff },
    ]
  }
];

function ApiToolsApp() {
  return (
    <ToolAppLayout
      title="API Tools"
      description="Debug, test, and analyze API endpoints and webhooks."
      toolCategories={toolCategories}
      basePath="/api-tools"
    />
  );
}

export default ApiToolsApp;
